import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import {User, UserProfile, UserWork, UserContacts, UserSocial, UserSettings, Store} from '../user.model';
import {UsersService} from "../users.service";
@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss'],
})
export class UserDialogComponent implements OnInit {
  public form:FormGroup;
  public passwordHide:boolean = true;
  constructor(public dialogRef: MatDialogRef<UserDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public user: User,
              public usersService:UsersService,
              public fb: FormBuilder) {
    this.form = this.fb.group({
      id: null,
      username: [null, Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern("^[a-z0-9_-]{5,15}$")])],
      password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern("((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})")])],
      profile: this.fb.group({
        firstName: null,
        lastName: null,
        birthday: null,
        gender: null,
        // image: null
      }),
      work: this.fb.group({
        name: null,
        branch: this.fb.group({
          address1:null,
          openingHours1:null,
          address2:null,
          openingHours2:null
        }),
      }),
      contacts: this.fb.group({
        email: null,
        mainPhone: null,
        address: null          
      }),
      settings: this.fb.group({
        isActive: null,
        isDeleted: null,
        registrationDate: null,
        joinedDate: null
      })
    });
  }

  ngOnInit() {
    if(this.user){
      console.log(this.user)
      this.form.setValue(this.user);
    } 
    else{
      this.user = new User();
      this.user.profile = new UserProfile();
      this.user.work = new UserWork();
      this.user.contacts = new UserContacts();
      this.user.social = new UserSocial();
      this.user.settings = new UserSettings();
    } 
  }

  close(): void {
    this.dialogRef.close();
  }

  upsertUser() {
    const formForUi = this.form.value;
    let newStore = {}
    newStore['name'] = formForUi.work.name;
    newStore['website'] = formForUi.website;
    newStore['passwordDisplay'] = formForUi.password
    newStore['branchList'] = []
    newStore['branchList'].push({address: formForUi.work.branch.address1,openingHours: formForUi.work.branch.openingHours1})
    newStore['branchList'].push({address:formForUi.work.branch.address2,openingHours: formForUi.work.branch.openingHours2})
    newStore['branchList'].push({address:formForUi.work.branch.address3,openingHours: formForUi.work.branch.openingHours3})
    let user = {
      password: formForUi.password,
      username: formForUi.username,
      email: formForUi.contacts.email,
      firstName: formForUi.profile.firstName,
      lastName: formForUi.profile.lastName,
      mainPhone: formForUi.contacts.mainPhone,
      birthday: formForUi.profile.birthday,
      gender: formForUi.profile.gender,
      address: formForUi.contacts.address,
      active:formForUi.settings.isActive,
      blocked: formForUi.settings.isDeleted,
      image:formForUi.profile.image
    }
    newStore['user'] = user
    this.usersService.sendClickEvent()
    if(this.form.value.id != null){
     this.usersService.partialUpdateUser(formForUi, newStore).subscribe(res=>{
       this.usersService.sendClickEvent("loadStores");
       this.close();
     })
    }else{
      this.usersService.addStore(newStore).subscribe(res=>{
        this.usersService.sendClickEvent("loadStores");
        this.close();
      });
    }
  }
}
